const Loading = () => {
  return (
    <div className="flex justify-center items-center" style={{height: '100svh'}}>loading</div>
  )
}

export default Loading